import styled from 'styled-components';

const FooterFooter = styled.footer`
  background-color: rgba(0, 0, 0, 0.67);
  height: auto;
  padding: 0 20px;
  width: 100%;

  > div {
    max-width: 1278px;
    margin: 0 auto;
    padding: 34px 0 26px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width : 1023px) {
      padding: 30px 0;
    }
  }

  .copyright-text {
    font-family: "Eina01-Medium";
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #C2C2C2;

     @media only screen and (max-width : 1023px) {
      margin-bottom: 15px;
      text-align: center;
    }
  }

  @media only screen and (max-width : 1023px) {
    height: auto;

    > div {
      flex-direction: column;
    }
  }
`;

const FooterPrivacidadeDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;

  .link {
    font-size: 12px;
    line-height: 15px;
    font-weight: 400;
    font-family: "Eina01-Medium";
    color: #FFFFFF;
    text-decoration: none;
    max-width: 92px;
    text-align: center;
    transition: all ease-in-out 0.3s;

    &:hover {
      color: #D4FC00;
    }
  }

  @media only screen and (max-width : 1023px) {
    gap: 15px 0;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    .link {
      max-width: 100%;
      padding: 0 10px;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        width: 2px;
        height: 10px;
        background-color: #ffffff;
      }

      &:first-of-type {
        padding-left: 0;
      }

      &:last-of-type {
        padding-right: 0;

        &:after {
          display: none;
        }
      }
    }
  }
`;

const FooterSocialNetworksDiv = styled.div`
  display: flex;
  gap: 22px;
  align-items: center;
  margin-left: 40px;

  .icon {
    color: #FFFFFF;
    font-size: 16px;
  }

  .link {
    height: 16px;

    &:last-child {
      margin: 0;
    }
  }

  @media only screen and (max-width : 1023px) {
    justify-content: center;
    width: 100%;
    margin-left: 0;

    .link {
      padding: 0;

      &:after {
        display: none;
      }
    }
  }
`;

const FooterAssinaturaDiv = styled.div`
  display: flex;
  height: 22px;
  width: auto;

  @media only screen and (max-width : 1023px) {
    margin-top: 15px;
  }
`;

export {
  FooterFooter,
  FooterPrivacidadeDiv,
  FooterSocialNetworksDiv, 
  FooterAssinaturaDiv
}